/**
 * Created by trump on 16/7/16.
 */
import "../../../_core/libRequirePathHelper";
import _ from "lodash";

require('../../../../bower_components/animate.css');

if (!window.jQuery) {
    window.jQuery = window.$ = require('../../../../bower_components/jquery/dist/jquery');
    window.jQuery.mf_app = 'mf_app';
}

/**
 * @global mf_app
 * @name mf_app
 * @namespace window.mf_app
 * */
var mf_app = window.mf_app = {
    isEditingMode: !!top.EditorApp,
    getPluginData(pluginId) {
        return this.allPlugins[pluginId];
    },
    getELPluginData($el) {
        return this.getPluginData($($el).attr('data-id'));
    },
    getElById(id) {
        return $(`#plugin-${id}`);
    },
    allPlugins: {},
    getPluginsByType(type) {
        var allKeys = _.keys(this.allPlugins);
        var validKeys = _.filter(allKeys, p => this.allPlugins[p].type === type);
        return _.map(validKeys, p => this.allPlugins[p]);
    },
    libs: {},
    addLib(pluginType, lib) {
        var pluginLibs = this.libs[pluginType] || (this.libs[pluginType] = []);
        pluginLibs.push(lib);
        lib.initAll && $(() => lib.initAll());
    },
    getLib(type) {
        return this.libs[type] || [];
    },
};

(function initPluginData(plugins) {
    plugins && _(plugins).each(plugin => {
        mf_app.allPlugins[plugin.id] = plugin;
        if (plugin.items && plugin.items.length) {
            initPluginData(plugin.items);
        }
    })
})(window._PAGE_DATA_);




// WEBPACK FOOTER //
// ./_share.pluginLibs/libs/common/index.js